import * as LDClient from 'launchdarkly-js-client-sdk';
import { RunFlagsDeps, RunFlagsResult } from '../types';

/**
 * Initialize LaunchDarkly with the full user context and resolve when the
 * client settles. Resolves on `ready` OR `failed`/`error` — a hard LD failure
 * must not hang app initialization.
 */
export const runFlags = ({
	clientSideID,
	liveUpdates,
	context,
	onChange,
	initialize = LDClient.initialize,
}: RunFlagsDeps): Promise<RunFlagsResult> => {
	return new Promise<RunFlagsResult>(resolve => {
		if (!clientSideID) {
			resolve({ flags: {}, client: null });
			return;
		}

		const client = initialize(clientSideID, context, {
			streaming: !!liveUpdates,
		});

		let settled = false;
		const settle = () => {
			if (settled) return;
			settled = true;
			client.off('ready', settle);
			client.off('failed', settle);
			client.off('error', settle);
			resolve({ flags: client.allFlags(), client });
		};

		// `ready` fires regardless of connection success; `failed`/`error`
		// cover hard init failures so we never hang.
		client.on('ready', settle);
		client.on('failed', settle);
		client.on('error', settle);

		if (liveUpdates && onChange) {
			client.on('change', () => onChange(client.allFlags()));
		}
	});
};
